import societySlide from "@/components/societySlide/societySlide.vue";

export default {
    components: {
        societySlide,
    },

    props: {
        data: {
            type: Object,
            require: true,
        },
    },

    data() {
        return {
            societyNum: 0,
        }
    },

    methods: {
        carouselBack() {
            this.societyNum -= 1;
        },

        carouselForward() {
            this.societyNum += 1;
        },
    },
}
